import moment from 'moment';
import { formatItalianNumber } from './engine';

/**
 * Tag disponibili per template: template_invoice_customer
 *
 * TESTATA:
 *   {internalCode}       - Codice interno fattura
 *   {date}               - Data fattura (DD/MM/YYYY)
 *   {customerCode}       - Codice cliente
 *   {vatNumberCustomer}  - P.IVA cliente
 *   {fiscalCode}         - Codice fiscale cliente
 *   {customerEmail}      - Email cliente
 *   {phoneCustomer}      - Telefono cliente
 *   {nameCustomer}       - Nome cliente
 *   {addressCustomer}    - Indirizzo cliente
 *   {salesAgent}         - Agente di vendita
 *   {paymentCondition}   - Condizione di pagamento
 *   {bankCustomer}       - Banca cliente
 *   {incoterms}          - Incoterms
 *   {orderNumber}        - Numero ordine
 *   {orderDate}          - Data ordine (DD/MM/YYYY)
 *   {externalCode}       - Codice esterno ordine
 *   {tablePayments}      - Tabella pagamenti
 *
 * RIGHE (loop {#rows}...{/rows}):
 *   {code}           - Codice articolo
 *   {description}    - Descrizione
 *   {um}             - Unita di misura
 *   {quantity}       - Quantita
 *   {price}          - Prezzo unitario
 *   {discount}       - Sconto
 *   {total}          - Totale riga
 *   {vatPercentage}  - Percentuale IVA
 *
 * TOTALI:
 *   {totalImponibile} - Totale imponibile
 *   {totalIva}        - Totale IVA
 *   {totalPrice}      - Totale fattura
 *
 * Extra args: order, rows, paymentConditionName
 */

export default {
    tags: {
        internalCode: 'internalCode',
        date: { path: 'date', format: 'date' },
        customerCode: 'idCustomer.code',
        vatNumberCustomer: 'vatNumberCustomer',
        phoneCustomer: 'phoneCustomer',
        nameCustomer: 'nameCustomer',
        addressCustomer: 'addressCustomer',
        bankCustomer: 'bankCustomer',
        orderNumber: 'orderNumber',
        tablePayments: 'tablePayments',
    },

    // Le righe vengono passate come extra arg, non da data.rows
    // quindi le gestiamo in computed
    computed: (invoice, order, rows, paymentConditionName) => {
        return {
            fiscalCode: order?.idCustomer?.fiscalCode || '',
            customerEmail: order?.idCustomer?.email || '',
            salesAgent: order?.idSalesAgent?.name || '',
            paymentCondition: paymentConditionName || invoice.paymentConditionCustomer || '',
            incoterms: invoice.incotermsCustomer || '',
            orderDate: order ? moment(order.orderDate).format('DD/MM/YYYY') : '',
            externalCode: order?.externalCode || '',
            rows: (rows || []).map(row => ({
                code: row.idItemModel?.code || row.codeItemModel || '',
                description: row.name || row.nameItemModel || '',
                um: row.measureUnit || row.unitItemModel || 'NR',
                quantity: row.quantity || '',
                price: row.price ? formatItalianNumber(row.price, 2) + ' €' : '',
                discount: row.discountItemModel ? row.discountItemModel + '%' : '',
                total: row.totalRow ? formatItalianNumber(row.totalRow, 2) + ' €' : '',
                vatPercentage: row.idVatCondition?.percentage != null ? row.idVatCondition.percentage + '%' : '',
            })),
            totalImponibile: formatItalianNumber(invoice.totalImponibile || 0, 2) + ' €',
            totalIva: formatItalianNumber(invoice.totalIva || 0, 2) + ' €',
            totalPrice: formatItalianNumber(invoice.totalPrice || 0, 2) + ' €',
        };
    }
};
